import script from "./Ticket.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ticket.vue?vue&type=script&setup=true&lang=ts"

import "./Ticket.vue?vue&type=style&index=0&id=0b97342e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b97342e"]])

export default __exports__